import * as React from 'react';

import * as styles from './pageSection.module.scss';

export interface PageSectionProps {
  children: React.ReactNode;
  noBottomPadding?: boolean;
}

const PageSection: React.FC<PageSectionProps> = ({
  children,
  noBottomPadding,
}) => {
  return (
    <section
      className={`${styles.wrapper} ${
        noBottomPadding && styles.noBottomPadding
      }`}>
      {children}
    </section>
  );
};

export default PageSection;
